import { render, staticRenderFns } from "./ExportLocationRegistrationForm.vue?vue&type=template&id=7aaf28f6&scoped=true&"
import script from "./ExportLocationRegistrationForm.vue?vue&type=script&lang=js&"
export * from "./ExportLocationRegistrationForm.vue?vue&type=script&lang=js&"
import style0 from "./ExportLocationRegistrationForm.vue?vue&type=style&index=0&id=7aaf28f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aaf28f6",
  null
  
)

export default component.exports